import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MetaDataModel } from '../../models/transaction-metadata-model';

@Component({
  selector: 'app-transaction-metadata-popup',
  templateUrl: './transaction-metadata-popup.component.html',
  styleUrls: ['./transaction-metadata-popup.component.css']
})
export class TransactionMetadataPopupComponent {

  public metadata = new MetaDataModel();

  constructor(
    public dialogRef: MatDialogRef<TransactionMetadataPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data && data.existingMetadata) {
      this.metadata = new MetaDataModel(data.existingMetadata);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.dialogRef.close(this.metadata);
  }
}